import React from 'react';

export default class AnswerButton extends React.Component {
	
		constructor(props) {
		super(props);
		
		console.log("AnswerButton:", props);
	}
	

	onClick(e) {
		console.log("AnswerButton::onClick:", e);
		if (this.props.disabled || this.props.questionTimerFinished) return;
		this.props.onClick(e);
		
	}
	render() {

		const disabled = this.props.disabled || this.props.questionTimerFinished ? " disabled" : "";
		const buttonClass = "btn btn-warning btn-xlarge" + disabled;
		return(
		<button type="button" className={buttonClass} id={this.props.answer.id} value={this.props.answer.answer} onClick={this.onClick.bind(this)} style={this.props.style}>{this.props.answer.answer}</button>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/AnswerButton/AnswerButton.js